import Request from '@/api/request';

const api = new Request('lk/statement/');
const apiDoc = new Request('lk/inDocuments/');

export function getUserNotifications(
  pageNumber: number = 0,
  pageSize: number = 10
): Promise<any> {
  return api
    .get(`getUserNotifications/?pageNumber=${pageNumber}&pageSize=${pageSize}`)
    .then((res: any) => {
      return res;
    });
}

export function getUserTopNotifications(
  pageNumber: number = 0,
  pageSize: number = 3
): Promise<any> {
  return (
    api
      .get(
        `getUserNotifications/?pageNumber=${pageNumber}&pageSize=${pageSize}&onlyNew=true&signPageNumber=0&signPageSize=1`
      )
      // .get(
      //   `getUserNotifications/?pageNumber=${pageNumber}&pageSize=${pageSize}&onlyNew=true`
      // )
      .then((res: any) => {
        return res;
      })
  );
}

export function getCountNewUserNotifications(
  pageNumber: number = 0,
  pageSize: number = 0
): Promise<any> {
  return api
    .get(
      `getUserNotifications/?pageNumber=${pageNumber}&pageSize=${pageSize}&onlyNew=true`
    )
    .then((res: any) => {
      return res;
    });
}

export function sendReadNotifications(data: any): Promise<any> {
  return api.post(`sendReadNotifications`, data).then((res: any) => {
    return res;
  });
}

export function markAllNotificationsRead(): Promise<any> {
  return api.post('markAllNotificationsRead').then((res: any) => {
    return res;
  });
}

// notifications-documents
export function getNotificationsDoc(query: any): Promise<any> {
  let queryString = '';
  for (const key in query) {
    queryString += `&${key}=${query[key]}`;
  }
  queryString = queryString.slice(1);
  return apiDoc.get(`getDocuments/?${queryString}`).then((res: any) => {
    return res;
  });
}

export function getNotificationsDocId(id: string): Promise<any> {
  return apiDoc.get(`getDocument/?id=${id}`).then((res: any) => {
    return res;
  });
}

export function sendReadNotificationsDoc(data: any): Promise<any> {
  return apiDoc.post(`sendReadNotifications`, data).then((res: any) => {
    return res;
  });
}
